module.exports = __webpack_public_path__ + "static/media/5.ef532afd.jpeg";